import { z } from 'zod';
import { UnixTimestamp } from 'libs/end-to-end/src/types/databases/analysis/database-analysis';

export const RubricBankConstructItem = z.object({
  id: z.string(),
  key: z.string().default(''),
  rubricId: z.string(),
});

export type RubricBankConstructItem = z.infer<typeof RubricBankConstructItem>;

export const RubricBankConstruct = z.object({
  id: z.string(),
  name: z.string(),
  items: z.array(RubricBankConstructItem),
  createdBy: z.string(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp.nullable(),
});

export type RubricBankConstruct = z.infer<typeof RubricBankConstruct>;

export const RubricBankConstructForWrite = RubricBankConstruct.omit({
  id: true,
});

export type RubricBankConstructForWrite = z.infer<
  typeof RubricBankConstructForWrite
>;
